import * as React from 'react'
import './App.css'
import { Switch, Route, Redirect } from 'react-router'

import Login from './screens/Login'
import Dashboard from './screens/Dashboard'
import MyLoans from './screens/MyLoans'
import UsersList from './screens/UsersList'
import CreateUser from './screens/CreateUser'
import CreateLoan from './screens/CreateLoan'
import SecureRoute from './components/SecureRoute'
import NotLoggedRoute from './components/NotLoggedRoute'
import LoanDetail from './screens/LoanDetail'
import LoanPayment from './screens/LoanPayment'
import ForgotPassword from './screens/ForgotPassword'
import AccountActivate from './screens/AccountActivate'
import AccountForgottenPassword from './screens/AccountForgottenPassword'
import { UserRole } from './graphql/queries/me'
import Footer from './components/Footer'

export interface AppProps {}

const App: React.SFC<AppProps> = () => {
  return (
    <React.Fragment>
      <Switch>
        <Route exact={true} path="/" render={() => <Redirect to="/my-loans" />} />
        <SecureRoute
          exact={true}
          path="/loans"
          component={Dashboard}
          role={UserRole.ADMIN}
        />
        <SecureRoute exact={true} path="/my-loans" component={MyLoans} />
        <SecureRoute
          exact={true}
          path="/users"
          component={UsersList}
          role={UserRole.ADMIN}
        />
        <SecureRoute
          exact={true}
          path="/users/create"
          component={CreateUser}
          role={UserRole.ADMIN}
        />
        <SecureRoute exact={true} path="/loans/create" component={CreateLoan} />
        <SecureRoute path="/loans/payment/:id" component={LoanPayment} />
        <SecureRoute path="/loans/:id" component={LoanDetail} />
        <NotLoggedRoute path="/login" component={Login} />
        <NotLoggedRoute path="/forgotten-password" component={ForgotPassword} />
        <NotLoggedRoute path="/account/activate" component={AccountActivate} />
        <NotLoggedRoute
          path="/account/forgotten-password"
          component={AccountForgottenPassword}
        />
      </Switch>
      <Footer />
    </React.Fragment>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/App.tsx